/**
 * Group name length constraints.
 * Shared by API helpers and UI so frontend validation matches backend.
 * Backend (server) uses same values; see server/src/routes/groups.js.
 */
export const GROUP_NAME_MIN_LENGTH = 3
export const GROUP_NAME_MAX_LENGTH = 30
